module.exports = __webpack_public_path__ + "static/media/Logo.cc807f31.svg";